import '@ice-web-app/shared-i18n';
import { Toast } from '@ice-web-app/shared-ui-ssr';
import { ConvexProvider, ConvexReactClient } from 'convex/react';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles.css';

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <ConvexProvider client={convex}>
      <BrowserRouter>
        <App />
        <Toast />
      </BrowserRouter>
    </ConvexProvider>
  </StrictMode>,
);
